import { render, staticRenderFns } from "./Addvideo.vue?vue&type=template&id=6e62e2c1&scoped=true"
import script from "./Addvideo.vue?vue&type=script&lang=js"
export * from "./Addvideo.vue?vue&type=script&lang=js"
import style0 from "./Addvideo.vue?vue&type=style&index=0&id=6e62e2c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e62e2c1",
  null
  
)

export default component.exports